import { isOfType } from '../../../../ts-utils';
export const RESOURCE_COMPONENT_UNMOUNTED = 'RESOURCE_COMPONENT_UNMOUNTED';
export const resourceComponentUnmounted = (payload) => ({
    type: RESOURCE_COMPONENT_UNMOUNTED,
    payload,
});
export const RESOURCE_COMPONENT_MOUNTED = 'RESOURCE_COMPONENT_MOUNTED';
export const resourceComponentMounted = (payload) => ({
    type: RESOURCE_COMPONENT_MOUNTED,
    payload,
});
export const isLifecycleAction = isOfType([
    RESOURCE_COMPONENT_UNMOUNTED,
    RESOURCE_COMPONENT_MOUNTED,
]);
//# sourceMappingURL=lifecycle-actions.js.map